/**
 * Uses default Object3D traverse or the custom one if the default is not provided.
 * @param obj - Object3D ThreeJS object
 * @param cb - callback, receives children object as parameter
 */
export function traverse(obj: any, cb: (obj: any) => void) {
  if (obj?.traverse) {
    obj.traverse(cb);
    return;
  }

  if (obj?.children?.length) {
    obj.children.forEach((child: any) => {
      if (obj?.children?.length) {
        traverse(child, cb);
      }
      cb(child);
    });
  }
}

/**
 * @param mesh - Mesh ThreeJS object
 */
export function disposeMesh(mesh: any) {
  mesh.geometry?.dispose();
  if (Array.isArray(mesh.material)) {
    for (let i = 0; i < mesh.material.length; i++) {
      mesh.material?.[i].dispose();
    }
  } else {
    mesh.material?.dispose();
  }
  if (typeof mesh.removeFromParent === 'function') {
    mesh.removeFromParent();
  }
}

/**
 * @param object - Object3D ThreeJS object
 */
export function disposeObject(object: any) {
  const cb = (obj) => {
    if (!obj.isMesh) return;
    disposeMesh(obj);
  };

  // Object3D should have traverse function
  if (object?.traverse) {
    object.traverse(cb);
  } else {
    traverse(object, cb);
  }
}
